import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LikeAggrigatorModel } from '@shared/model/Activity_Aggtigator/like-aggrigator-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { Observable, of, switchMap } from 'rxjs';
import { LikeModel } from '@shared/model/customerModels/like-model';



@Injectable({
        providedIn: 'root'
})

export class LikeAggrigatorService extends HttpBaseService {

        constructor() {
                const repo = inject(LocalRepository);
                const http = inject(HttpClient);

                super(repo, http, 'v1/liAggr');
        }

        getLikeByItem(itemId: string, termFilter?: TermFilterModel): Observable<TServiceResult<PageList<LikeAggrigatorModel>>> {
                const params = this.TermFilterParams(termFilter)
                return this.http.get<TServiceResult<PageList<LikeAggrigatorModel>>>(`${this.apiUrl}/GetLikesByItem/${itemId}${params}`);
        }



        getLike(like: LikeModel): Observable<TServiceResult<string>> {
                return this.http.post<TServiceResult<string>>(`${this.apiUrl}/Like`, like).pipe(
                        switchMap((res) => {
                                return of(res);
                        })
                )
        }


}